"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reloadAppointment = exports.loadNextAppointment = exports.SET_SELECTED_APPOINTMENT = void 0;
var _propTypes = _interopRequireWildcard(require("prop-types"));
var _myAppointmentApi = require("../../../csc/api/myAppointmentApi");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
var SET_SELECTED_APPOINTMENT = exports.SET_SELECTED_APPOINTMENT = 'api/reducer/SET_APPOINTMENT_CONTRACT';
var myAppointmentSelectionAction = {
  data: (0, _propTypes.shape)({
    assOrderId: _propTypes.default.string.isRequired,
    innerData: _propTypes.default.object.isRequired
  }).isRequired,
  type: _propTypes.default.string.isRequired
};
var reloadAppointment = exports.reloadAppointment = function reloadAppointment(dispatch, contractAccountId, assOrderId) {
  var responseNextAppointmentPromise = (0, _myAppointmentApi.getNextAppointment)(contractAccountId, assOrderId);
  return responseNextAppointmentPromise.then(function (responseAppointment) {
    dispatch({
      type: SET_SELECTED_APPOINTMENT,
      data: {
        assOrderId: assOrderId,
        innerData: responseAppointment.data
      }
    });
  }).catch(function () {
    dispatch({
      type: SET_SELECTED_APPOINTMENT,
      data: {
        assOrderId: assOrderId,
        innerData: null
      }
    });
  });
};
var loadNextAppointment = exports.loadNextAppointment = function loadNextAppointment(dispatch, contractAccountId) {
  if (contractAccountId) {
    (0, _myAppointmentApi.getAppointmentId)(contractAccountId).then(function (responseAppointmentIds) {
      var _responseAppointmentI;
      var selectedAssOrderIds = (_responseAppointmentI = responseAppointmentIds.data) === null || _responseAppointmentI === void 0 ? void 0 : _responseAppointmentI.assOrderIds;
      if (selectedAssOrderIds) {
        var assOrderId = selectedAssOrderIds[0];
        reloadAppointment(dispatch, contractAccountId, assOrderId);
      }
    });
  }
};